import { ContactVerificationModal, SecurityCard } from "@housebets/housebets-x-package";
import React from "react";
import { useIntl } from "react-intl";
import { useGTMEvents } from "app/hooks/useGTMEvents";
import { useEmailVerificationData } from "./hooks/useEmailVerificationData";
import { EmailVerificationForm } from "../../../forms";

export const EmailVerification: React.FC = () => {
    const {
        isModalOpen,
        setIsModalOpen,
        emailStatus
    } = useEmailVerificationData();
    const { modal } = useGTMEvents();
    const { formatMessage: t } = useIntl();

    const isVerified = emailStatus !== 0;

    return (
        <>
            <SecurityCard
                title={t({ id: "EmailVerification.title" })}
                text={t({
                    id: isVerified ? "EmailVerification.verified" : "EmailVerification.unverified"
                })}
                verifiedButtonText={t({ id: "EmailVerification.button.verified" })}
                submitButtonText={t({ id: "EmailVerification.button.unverified" })}
                onClick={() => setIsModalOpen(true)}
                verified={isVerified}
            />

            <ContactVerificationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                afterOpenModal={() => modal.show("contact_verification")}
                onAfterClose={() => modal.close("contact_verification")}
            >
                <EmailVerificationForm
                    onSubmit={() => setIsModalOpen(false)}
                />
            </ContactVerificationModal>
        </>
    );
};

EmailVerification.displayName = "EmailVerification";
